//ChangerIncomeByDateViewModel
(function() {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory(
      "ChangerIncomeByDateViewModel",
      changerIncomeByDateViewModelFactory
    );

  /** @ngInject */
  function changerIncomeByDateViewModelFactory(
    reportActions,
    localeFilters,
    reportsFilterStore,
    dispatcher,
    ActionTypesEnum,
    sortArrayService
  ) {
    function ChangerIncomeByDateViewModel() {
      this._reportsFilterStoreChangeHandler = null;
      this.total = 0;
      this.dailyData = false;
      this.totalByGroupName = [];
      this.chart = {
        data: null,
        chartType: "bar"
      };

      init.call(this);
    }

    ChangerIncomeByDateViewModel.prototype.destroy = function() {
      reportsFilterStore.off(
        reportsFilterStore.events.CHANGE,
        this._reportsFilterStoreChangeHandler
      );
    };

    return ChangerIncomeByDateViewModel;

    function init() {
      var that = this;
      this.isChartVisible = false;

      searchByFilter.call(that);
      this._reportsFilterStoreChangeHandler = function() {
        searchByFilter.call(that);
      };

      reportsFilterStore.on(
        reportsFilterStore.events.CHANGE,
        this._reportsFilterStoreChangeHandler
      );
    }

    function searchByFilter() {
      var that = this,
        reportFilterData = reportsFilterStore.getFilterData();

      that.dailyData = reportFilterData.fromTimestamp === reportFilterData.toTimestamp;
      that.totalByGroupName = [];

      if (!reportFilterData.selectedFacilitySerial) {
        return;
      }

      var from =
        reportFilterData.period3From > 0
          ? reportFilterData.fromTimestamp +
            reportFilterData.period3From * 3600000
          : reportFilterData.fromTimestamp;

      var to =
        reportFilterData.period3To > 0
          ? reportFilterData.toTimestamp +
            reportFilterData.period3To * 3600000 -
            1
          : reportFilterData.toTimestamp;

      reportActions
        .getChangerIncomePerDate(
          reportFilterData.selectedFacilitySerial,
          from,
          to, reportFilterData.currency
        )
        .then(function(successData) {
          //successData.unit = 'TOTAL_USERS_BY_GROUP_USERS_UNIT';
          successData.groupsData =
            successData.groupsData.length > 0
              ? sortArrayService.sortByGroupValue(successData.groupsData)
              : successData.groupsData;
          that.chart.data = successData;
          that.chart.x = {
            type: "x",
            tick: {
              culling: { max: 15 },
              rotate: 60,
              format: function(item) {
                return that.dailyData ? localeFilters.checkIfNumber(item) : localeFilters.date(item);
              }
            }
          }
          that.total = successData.total
          that.unit = successData.unit;
          that.isChartVisible = successData.total !== 0 ? true : false;
          dispatcher.dispatch({
            type: ActionTypesEnum.HIDE_LOADER
          });
        });
    }
  }
})();
